<template>
  <VDataGridV2
    :loader="dataLoader"
    sticky
    entity-type="budgetPrice"
    clickable
    :context-menu="BudgetPricesService.contextMenu"
    @row:dblclick="openBudgetPriceCard"
  >

    <VDataGridColumnV2
      id="code"
      label="Артикул"
      width="120px"
      content-align="center"
      filterable
      filter-send-name="code"
      :filter-props="{ placeholder: 'Введите артикул', clearable: true }"
    >
      <template #default="{ row }">
        {{ row.product.code || '--' }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="product"
      label="Название продукта"
      content-class="ellipsis"
      width="400px"
      filterable
      filter-send-name="pattern"
      :filter-props="{ placeholder: 'Введите название товара', clearable: true }"
    >
      <template #default="{ row }">
        {{ row.product }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="price"
      label="Цена"
      width="250px"
      content-align="right"
      header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.price.format(row.currency, row.product.unit) }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="price"
        label="Цена рассчитанная"
        width="250px"
        content-align="right"
        header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.price.formatInDisplayCurrency(row.currency, rateDate, row.product.unit) }}
      </template>
    </VDataGridColumnV2>

    <!-- комментирую кнопку, так как пока не выявлено целесообразности
    создания бюджетной цены из реестра бюджетных цен.
    <VDataGridActionBarV2>
      <template #default>
        <VButton @click="openBudgetPriceCard">
          Создать бюджетную цену
        </VButton>
      </template>
    </VDataGridActionBarV2>-->
  </VDataGridV2>
</template>

<script lang="ts">
import DataGridLoader      from "@/lib/components/VDataGridV2/DataGridLoader";
import BudgetPricesService from "@/domains/BudgetPrices/BudgetPricesService";
import BudgetPrice         from "@/domains/BudgetPrices/BudgetPrice";
import Core                from "@/core/Core";
import DateSimple          from "@/core/types/DateSimple";
import CurrenciesService   from "@/domains/Currencies/CurrenciesService";

export default {
  name: "BudgetPricesRegistry",

  setup() {
    return {
      BudgetPricesService,
    }
  },

  data() {
    return {
      dataLoader: new DataGridLoader(BudgetPricesService.getListPaginated),
      rateDate: DateSimple.today(),
      displayCurrency: CurrenciesService.displayCurrency
    }
  },

  methods: {
    async openBudgetPriceCard(budgetPrice?: BudgetPrice): Promise<void> {
      if (await Core.dialogs.BudgetPriceCard.showAsPromise({ productId: budgetPrice?.product?.id })) {
        await this.dataLoader.refresh();
      }
    }
  },
}
</script>
